module.exports = __webpack_public_path__ + "img/brawler.e4da89da.png";